export const COMPRAS_DIRETA_ITENS = 'COMPRAS_DIRETA_ITENS';
export const COMPRAS_DIRETA_ITENS_START = 'COMPRAS_DIRETA_ITENS_START';
export const COMPRAS_DIRETA_ITENS_SUCCESS = 'COMPRAS_DIRETA_ITENS_SUCCESS';
export const COMPRAS_DIRETA_ITENS_ERROR = 'COMPRAS_DIRETA_ITENS_ERROR';
